import buildTextInputDefinition, {
    TextInputDefinition
} from "../../../../../../../../utils/forms/models/grid-fields/text-input-definition";
import buildHiddenInputDefinition, {
    HiddenInputDefinition
} from "../../../../../../../../utils/forms/models/grid-fields/hidden-input-definition";
import { FormDefinition } from "../../../../../../../../utils/forms/builders/build-form-grid-fields";
import buildGameSelectorDefinition, {
    GameSelectorDefinition
} from "../../../../../../../../utils/forms/models/grid-fields/game-selector-definition";

export enum SCHEMA_NAMES {
    ID = "id",
    NAME = "name",
    GAME_INSTANCES = "game_instances",
    BUNDLES = "bundles",
    GROUPS = "groups"
}

const GAME_INSTANCES: (
    selectedGames: (string | number)[],
    completeList: { label: any; value: string | number }[],
    bundlesList: { label: any; value: string | number; games: any[] }[]
) => GameSelectorDefinition = (selectedGames, completeList, bundlesList) => {
    return buildGameSelectorDefinition({
        name: "game_instances",
        id: "game_instances",
        label: "Game Bundles",
        schemaName: SCHEMA_NAMES.GAME_INSTANCES,
        completeList: completeList,
        bundlesList,
        selectedGames,
        fieldOverrides: {
            multipleSelection: true,
            formSpacing: false
        }
    });
};

const ID_INPUT: HiddenInputDefinition = buildHiddenInputDefinition({
    name: "id",
    placeholder: "ID",
    id: "GroupConfigID",
    label: "ID",
    schemaName: SCHEMA_NAMES.ID,
    fieldOverrides: { formSpacing: false }
});

const NAME_INPUT: TextInputDefinition = buildTextInputDefinition({
    name: "name",
    placeholder: "Name",
    id: "GroupConfigName",
    label: "Name",
    schemaName: SCHEMA_NAMES.NAME,
    fieldOverrides: { formSpacing: false }
});

export function gameGroupFormDefinition(
    fullInstanceList?: { label: any; value: string | number }[],
    selectedInstanceList?: (string | number)[],
    fullGameBundles?: { label: any; value: string | number; games: any[] }[]
): FormDefinition {
    return {
        [SCHEMA_NAMES.ID]: {
            definition: ID_INPUT,
            order: 0
        },
        [SCHEMA_NAMES.NAME]: {
            definition: {
                ...NAME_INPUT,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"
                }
            },
            order: 1
        },
        [SCHEMA_NAMES.GROUPS]: {
            definition: {
                ...GAME_INSTANCES(
                    selectedInstanceList,
                    fullInstanceList,
                    fullGameBundles
                ),
                fieldOverrides: {
                    formSpacing: false,
                    multipleSelection: true,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                }
            },
            order: 2
        }
    };
}
